import InputLiveUpdater from "../ui/components/InputLiveUpdater";

const ItemRowConciliacion = ({r, i, headers, headersTableActive, debounceUpdate, setRecord}) => {
  return (
    <>
      {headers.map((header) => (
        headersTableActive.find((e) => e.id === header.id)?.show && (
          <td key={header.id} className="px-4 py-2 whitespace-nowrap text-center border border-gray-300">  
            {header.input ? (
              <InputLiveUpdater
                value={r[header.content]}
                field={header.content}
                placeholder={header.name}
                route="conciliacion"
                id={r.id}
                debounceUpdate={debounceUpdate}
                setElements={setRecord}
                width="w-[15rem]"
              />
            ) : (
              header.formatter ? header.formatter(r[header.content]) : r[header.content]
            )}
          </td>
        )
      ))}
    </>
  )
}

export default ItemRowConciliacion;